import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {blockUser, reportPostAsInappropriate} from "../../modules/Detail/actions";
import {useDispatch} from "react-redux";

const AlertDialog = (props) => {
  const dispatch = useDispatch();
  return (
    <div>
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.description}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            props.handleClose();
            props.menuClose();
          }} color="primary">
            いいえ
          </Button>
          <Button onClick={() => {
            props.handleClose();
            props.menuClose()
            switch (props.type) {
              case 'report':
                dispatch(reportPostAsInappropriate());
                break;
              case 'block':
                dispatch(blockUser());
                break;
            }
          }} color="primary" autoFocus>
            はい
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default AlertDialog
